module.exports = __webpack_public_path__ + "static/media/01_b_photo.086b6c04.png";